import axios from 'axios';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

export const optionsFetcher = async (url: string) => {
    const res = await axios.options(url);
    return res.data;
};

export function useBasePath() {
    const location = useLocation();
    const { i18n } = useTranslation();
    // Supported locales (customize based on your app's supported languages)
    const supportedLocales = ['en', 'de', 'fr'];

    // Extract the path segments
    const pathSegments = location.pathname.split('/').filter(Boolean);

    // Determine if the first segment is a locale
    const isLocale = pathSegments[0]
        ? supportedLocales.includes(pathSegments[0])
        : false;
    const locale = isLocale ? pathSegments[0] : i18n.language; // Fallback to `i18n.language` if no locale

    return isLocale ? `/${locale}` : '';
}

export function getTon(obj: number): number {
    const kgRange: [number, number] = [-999, 1000];

    if (obj < kgRange[0] || obj >= kgRange[1]) {
        return Math.round((obj / 1000) * 10) / 10;
    }

    return obj;
}

export function getKgOrTon(obj: number): string {
    const kgRange: [number, number] = [-999, 1000];

    if (obj < kgRange[0] || obj >= kgRange[1]) {
        return ' t';
    }

    return ' kg';
}
